var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[(!_vm.$store.getters['display/isError'])?_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }